import { useQuery } from '@tanstack/react-query';
import { Descriptions, Divider, Flex, Grid, Skeleton, Typography } from 'antd';
import Parser from 'html-react-parser';
import { Fragment, useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getResignationTicket } from 'src/apis/hr_ticket/resignationTicket.api';
import { BtnHrHandle } from 'src/components/v2/Button';
import { HRTicketStatusTag } from 'src/components/v2/Tag/TicketStatusTag/TicketStatusTag';
import { ConfirmTypeEn } from 'src/constants/confirmTypeEn.enum';
import { AppContext } from 'src/contexts/app.context';
import { HrTicketDetailContext } from 'src/contexts/hrTicketDetail.context';
import { TicketContext } from 'src/contexts/ticket.context';
import { formatDate } from 'src/utils/utils';
import './ResignationTicketDetail.scss';
const { Title, Text } = Typography;

export default function ResignationTicketDetail() {
  const { setResignationTicket, setLoading } = useContext(HrTicketDetailContext);
  const { setInvalidKey } = useContext(TicketContext);
  const { ticketSelected } = useContext(AppContext);
  const { id } = useParams();

  const { useBreakpoint } = Grid;
  const breakpoints = useBreakpoint();
  const colspan = breakpoints.xxl ? 2 : 1;

  const { data, isFetching } = useQuery({
    queryKey: ['resignationTicket', id],
    queryFn: () => getResignationTicket(Number(id)),
    enabled: !!id && !!ticketSelected
  });

  useEffect(() => {
    if (data) {
      setResignationTicket(data);
      setLoading(isFetching);
      setInvalidKey(JSON.stringify(data?.data));
    }
  }, [data, isFetching, setResignationTicket, setLoading, setInvalidKey]);

  return (
    <div className='resignation-ticket-detail-wrapper'>
      <BtnHrHandle type='resignationTicket' />

      <Divider style={{ marginTop: 16, marginBottom: 16 }} />

      <Flex justify='start'>
        <Title level={5}>Thông tin phiếu</Title>
      </Flex>
      {isFetching ? (
        <Skeleton active />
      ) : (
        <Fragment>
          <Descriptions
            className='resignation-ticket-item-header'
            layout='horizontal'
            labelStyle={{ width: '135px' }}
            column={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 2 }}
          >
            <Descriptions.Item label='Mã phiếu'>{data?.data?.code}</Descriptions.Item>
            <Descriptions.Item label='Trạng thái'>
              <HRTicketStatusTag ticketStatus={data?.data.ticketStatus} hrConfirmedType={data?.data.hrConfirmedType} />
            </Descriptions.Item>
            <Descriptions.Item label='Người tạo'>
              <Text strong>{data?.data?.createdBy?.fullName}</Text>
            </Descriptions.Item>
            <Descriptions.Item label='Bộ phận'>{data?.data?.createdBy?.department?.name}</Descriptions.Item>
            <Descriptions.Item label='Loại hợp đồng'>{data?.data?.contractType?.name}</Descriptions.Item>
            <Descriptions.Item label='Ngày hết hạn hđ'>
              {data?.data?.contractType?.expirationDate ? formatDate(data?.data?.contractType?.expirationDate) : ''}
            </Descriptions.Item>
            <Descriptions.Item label='Chức vụ'>{data?.data?.position?.name}</Descriptions.Item>
            <Descriptions.Item label='Ngày thôi việc' span={colspan}>
              {formatDate(data?.data?.resignDate)}
            </Descriptions.Item>

            <Descriptions.Item label={'Lý do nghỉ việc'} span={colspan}>
              <Text strong italic>
                {Parser(data?.data?.reason || '')}
              </Text>
            </Descriptions.Item>
          </Descriptions>

          <Divider style={{ marginTop: 16, marginBottom: 16 }} />

          {data?.data?.hrConfirmedType === ConfirmTypeEn.Confirmed ? (
            <Fragment>
              <Title level={5}>Nhân sự</Title>
              <Descriptions
                layout='horizontal'
                labelStyle={{ width: '135px' }}
                column={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 2 }}
              >
                <Descriptions.Item label='Ghi chú của HR'>
                  <Text italic>{data?.data?.hrConfirmedNote}</Text>
                </Descriptions.Item>
                <Descriptions.Item label='Ngày xác nhận'>{formatDate(data?.data?.hrConfirmedDate)}</Descriptions.Item>
                <Descriptions.Item label='Người xác nhận'>
                  <Text strong>{data?.data?.hrConfirmedBy?.fullName}</Text>
                </Descriptions.Item>
              </Descriptions>
            </Fragment>
          ) : null}
          <Divider style={{ marginTop: 16, marginBottom: 16 }} />
          {data?.data?.approvals?.[0]?.approver?.id && (
            <Fragment>
              <Title level={5}>Trưởng bộ phận</Title>
              <Descriptions
                layout='horizontal'
                labelStyle={{ width: '135px' }}
                column={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 2 }}
              >
                <Descriptions.Item label='Ghi chú của trưởng bộ phận'>
                  <Text italic>{data?.data?.approvals?.[0]?.note}</Text>
                </Descriptions.Item>
                <Descriptions.Item label='Ngày xác nhận'>
                  {formatDate(data?.data?.approvals?.[0]?.createdDate)}
                </Descriptions.Item>
                <Descriptions.Item label='Người xác nhận'>
                  <Text strong>{data?.data?.approvals?.[0]?.approver?.fullName}</Text>
                </Descriptions.Item>
              </Descriptions>
            </Fragment>
          )}
        </Fragment>
      )}
    </div>
  );
}
